module.exports = __webpack_public_path__ + "static/media/6.1979e1d4.png";